import { useState } from "react";
import "../../Assets/Style/LocalShipment.scss";
import {
  TrackForm,
} from "./components/index";
import TrackResults from "./components/TrackResults";

const TrackShipment = () => {
  const [Tab, setTab] = useState(0);
  const [shipmentNumber, setShipmentNumber] = useState("");
  const [trackResults, setTrackResults] = useState();

  return (
    <div className="Local_Shipment_Wrapper">
      <div className="header">
        <h3>{Tab === 0 && "Track Shipment"}</h3>
      </div>

      <div className="Wrap">
        <div className="Right">
          {Tab === 0 && (
            <TrackForm
              setTab={setTab}
              shipmentNumber={shipmentNumber}
              setShipmentNumber={setShipmentNumber}
              setTrackResults={setTrackResults}
            />
          )}
        </div>
        <div className="Left">
          <div className="Terms">
            <TrackResults trackResults={trackResults} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackShipment;
